export const tyre = [0.05, 0.05, 0.05];
